import { useMemo } from "react";

export const capitalize = (str) => {
  // split the string into an array of words
  // const words = str.split(' ');

  if (str?.length > 0) {
    // capitalize the first letter of each word

    const capitalizedWords = str?.charAt(0)?.toUpperCase() + str?.slice(1);
    // join the words back into a string and return it
    return capitalizedWords;
  }

}

export const toRad = (x) => {
  return x * Math.PI / 180;
}


export const CalculateLatLngDistance = (lat1, lon1, lat2, lon2) => {

  const R = 6371; // Earth's radius in km
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return distance;

}



export const validatePassword = (password) => {
  // Check if password has a minimum of 8 characters
  if (password.length < 8) {
    return false;
  }

  // Check if password contains at least one letter
  const letterRegex = /[a-zA-Z]/;
  if (!letterRegex.test(password)) {
    return false;
  }

  // Check if password contains at least one digit
  const digitRegex = /\d/;
  if (!digitRegex.test(password)) {
    return false;
  }

  // Check if password contains at least one special character
  const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
  if (!specialCharRegex.test(password)) {
    return false;
  }

  return true;
}